// Vendors
import 'src/scripts/vendor/jquery'
// import 'src/scripts/vendor/bootstrap'
import 'src/scripts/vendor/lazysizes.min'
import 'src/scripts/vendor/lightgallery.min'
import 'src/scripts/vendor/glide.min'
import 'src/scripts/modules/nav'
import 'src/scripts/modules/table'
import 'src/scripts/modules/accordion'
import 'src/scripts/modules/gallery'
import 'src/scripts/modules/filter-blog'
import 'src/scripts/modules/popup'
import 'src/scripts/modules/search'
import 'src/scripts/modules/slider'
import 'src/scripts/modules/booking-app'
import 'src/scripts/modules/navlateral'